let lockedWindowScrollY = 0
let lockedContentScrollEl = null
let lockedContentScrollTop = 0
let contentScrollPinRaf = null

export function isDashboardReportViewportLocked() {  return document.body.classList.contains('dashboard-report-scroll-lock')
}

function pinLockedContentScroll() {
  if (!lockedContentScrollEl) return
  if (lockedContentScrollEl.scrollTop !== lockedContentScrollTop) {
    lockedContentScrollEl.scrollTop = lockedContentScrollTop
  }
}
function startContentScrollPinLoop() {
  const loop = () => {
    pinLockedContentScroll()
    contentScrollPinRaf = requestAnimationFrame(loop)
  }
  contentScrollPinRaf = requestAnimationFrame(loop)
}

function stopContentScrollPinLoop() {
  if (contentScrollPinRaf != null) {
    cancelAnimationFrame(contentScrollPinRaf)
    contentScrollPinRaf = null
  }
}

export function lockDashboardReportViewport(contentEl) {
  if (isDashboardReportViewportLocked()) return
  lockedWindowScrollY = window.scrollY || window.pageYOffset || 0
  document.body.classList.add('dashboard-report-scroll-lock')
  document.body.style.position = 'fixed'
  document.body.style.top = `${-lockedWindowScrollY}px`
  document.body.style.left = '0'
  document.body.style.right = '0'
  document.body.style.width = '100%'
  document.documentElement.style.overflow = 'hidden'

  lockedContentScrollEl =
    contentEl && contentEl instanceof HTMLElement
      ? contentEl
      : document.querySelector('.dashboardContent')
  if (lockedContentScrollEl) {
    lockedContentScrollTop = lockedContentScrollEl.scrollTop
    lockedContentScrollEl.classList.add('dashboard-report-content-locked')
    startContentScrollPinLoop()
  }}

export function unlockDashboardReportViewport() {
  stopContentScrollPinLoop()
  if (lockedContentScrollEl) {
    lockedContentScrollEl.classList.remove('dashboard-report-content-locked')
    lockedContentScrollEl.scrollTop = lockedContentScrollTop
    lockedContentScrollEl = null
    lockedContentScrollTop = 0
  }

  if (!isDashboardReportViewportLocked()) return
  document.body.classList.remove('dashboard-report-scroll-lock')
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.width = ''
  document.documentElement.style.overflow = ''
  window.scrollTo(0, lockedWindowScrollY)
  lockedWindowScrollY = 0
}

/**
 * Scroll chart panels for capture without moving the visible dashboard.
 * While locked, the main scroll position is pinned and charts are prepared off-screen.
 */
export function scrollElementForReportCapture(el, options = {}) {
  if (!el) return
  if (isDashboardReportViewportLocked()) {
    return
  }
  const block = options.block ?? 'center'
  const behavior = options.behavior ?? 'instant'
  el.scrollIntoView({ block, inline: 'nearest', behavior })
}
